<p-button
    icon="fas fa-filter"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Filter')"
    tooltipPosition="right"
    [label]="l('::Filter')"
    (onClick)="onClick()">    
</p-button>